/**
 * Groups collection by id property
 *
 * @param collection
 */
export const groupById = (collection) => {
    const groupedCollection = {};

    collection.forEach(({ id, ...rest }) => groupedCollection[id] = { id, ...rest });

    return groupedCollection;
};
